import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from '../../../ErrorBoundary';
import ContentShadow from '../_partials/ContentShadow';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import useDeviationDrag from '../../../Dnd/useDeviationDrag';
import s from './Film.scss';
export const FilmFullView = ({ deviation , height , width  })=>{
    const { dragPreview , drag  } = useDeviationDrag({
        deviation,
        width: 400,
        height: 400
    });
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    if (!videoFile) {
        return null;
    }
    const previewFile = DeviationMediaService.getDeviationFile(deviation, 'preview');
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FillFullView"
    }, /*#__PURE__*/ React.createElement(Helmet, null, previewFile && /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: previewFile.src,
        as: "image"
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: videoFile.src,
        as: "video"
    })), /*#__PURE__*/ React.createElement("div", {
        ref: drag
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(ContentShadow, {
        content: _object_spread_props(_object_spread({}, videoFile), {
            width,
            height
        }),
        containerSize: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(VideoPlayer, {
        width: width,
        height: height,
        src: videoFile.src,
        loadingCover: previewFile && previewFile.src,
        autoPlay: false
    })))), dragPreview);
};
FilmFullView.displayName = 'FilmFullView';
export default FilmFullView;
